import { planningAPI } from "../../axios";

export const actions = {

    //PapCategory
    GetPapCategory(context, data){
        return planningAPI.get(`PapCategory/All`);
    },
    GetSinglePapCategory(context, data){
        return planningAPI.get(`PapCategory/${data}`);
    },
    UpdatePapCategory(context, data){
        return planningAPI.put(`PapCategory/Update/${data.id}`, data);
    },
    DeletePapCategory(context, data){
        return planningAPI.delete(`PapCategory/Remove/${data}`);
    },
    CreatePapCategory(context, data){
        return planningAPI.post(`PapCategory/Add`, data);
    },

}